import React, { useState, useRef, useEffect } from "react";
import { Row, Col, Button } from "../../bootstrap/index.jsx";
import Select from "../../common/Select.jsx";
import ActionButtons from "./ActionButtons.jsx";
import { ACTION_TYPES } from "./phaseReducer.js";
import { ReadOnlyMultiSelectValues } from "../../common/Select.jsx";
import RichText from "../../common/RichText.jsx";
import LoadingIndicator from "../../common/loading_indicator.jsx";
import Help from "../../common/Help.jsx";

import {
  monitoring_report_update_phase_path,
  project_report_json_previous_phases_form_path
} from '~/routes';

const GeneralDetails = ({ report, phase, formOptions, fillPhase, dispatch, locale }) => {
  const [loading, setLoading] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [reviewers, setReviewers] = useState(
    ((phase.body || {}).reviewers || []).map((r) => ({ type: r.type, id: parseInt(r.id, 10) }))
  );
  const [name, setName] = useState((phase.body || {}).name || "");
  const [richTextContent, setRichTextContent] = useState((phase.body || {}).rich_text_content  || '')
  const [docs, setDocs] = useState(undefined);
    (phase.body || {}).sign_documents || []
  const [availableDocs, setAvailableDocs] = useState([]);
  const handleReviewerSelect = (selected) => {
    setReviewers(selected.map((s) => ({ type: s.split(":")[0], id: s.split(":")[1] })));
  };
  const handleDocsSelect = (selected) => {
    if (selected.length === 0){
      alert(I18n.t('empty_envelope_warning'))
    } else {
      setDocs(selected.map((s) => ({id: s, label: availableDocs.find((d) => d.id === s).name})))
    }
  }

  const formRef = useRef(null);

  const onSave = (e) => {
    e.preventDefault();
    jQuery.post(
      monitoring_report_update_phase_path({
        id: report.id,
        phase_id: phase.id,
        _options: true,
      }),
      jQuery(formRef.current).serialize(),
      (res) => {
        setEditMode(false);
        dispatch({ type: ACTION_TYPES.UPDATE_DATA, payload: { data: res.data } });
      }
    );
  };

  useEffect(() => {
    jQuery.getJSON(project_report_json_previous_phases_form_path({project_id: phase.fund_id, report_id: phase.monitoring_report_id, monitoring_report_phase_id: phase.id}), (res) => {
      const availDocs = res.map((r) => ({id: r.id, name: r.name[locale]}))
      setAvailableDocs(availDocs);
      if ((phase.body || {}).sign_documents) {
        setDocs((phase.body || {}).sign_documents.map((s) => ({id: s.id, label: availDocs.find((d) => d.id == s.id).name})));
      } else {
        setDocs(availDocs.map((d) => ({id: d.id, label: d.name})))
      }
      setLoading(false)
    })
  }, [])

  const reviewerDetails = reviewers
  .map((r) => formOptions.available_reviewers.find((ap) => ap.id == r.id && ap.type == r.type))
  .filter(Boolean);

  return (
  loading ? <LoadingIndicator /> :   
    <form ref={formRef}>
      <Row>
        <Col>
          <h3 style={{ display: "inline-block" }}>{I18n.t("general")}</h3>
          {!editMode && (
            <Button
              className="pull-right"
              onClick={(e) => {
                e.preventDefault();
                setEditMode(!editMode);
              }}
            >
              <i className="fa fa-pencil" />
            </Button>
          )}
        </Col>

        <Col size="xs-12" className="mb-1">
          <label>{I18n.t("name")}</label>
          {editMode ? (
            <input
              type="text"
              className="form-control"
              name="monitoring_report[name]"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
          ) : (
            <p>{name || "-"}</p>
          )}
          {editMode && <p className="description">{I18n.t("name_description")}</p>}
        </Col>

        <Col size="xs-12" className="mb-1">
          <div className='show-total-value'>
                <label>{I18n.t("message_to_signers")}</label>
                <Help text={I18n.t("additional_signing_info_description")} />
          </div>
          <RichText
                    fieldname="monitoring_report[rich_text_content]"
                    readOnly={!editMode}
                    preview={!editMode}
                    value={richTextContent}
                    updateAnswer={(val) => setRichTextContent(val)}
          />
          <div>
            <label>{I18n.t("initiators")}</label>
          </div>
          {editMode && <p className="description">{I18n.t("initiators_description")}</p>}
          {editMode ?
            <>
              <Select
                options={(formOptions.available_reviewers || []).map((r) => ({
                  value: `${r.type}:${r.id}`,
                  label: r.label,
                }))}
                value={reviewers.map((r) => `${r.type}:${r.id}`)}
                onChange={handleReviewerSelect}
                isMulti
              />
              {reviewers.map((r) => (
                <div key={`${r.type}-${r.id}`} className="d-none">
                  <input type="hidden" name="monitoring_report[reviewers][][id]" value={r.id} />
                  <input type="hidden" name="monitoring_report[reviewers][][type]" value={r.type} />
                </div>
              ))}
            </>
             : 
            <>
              {
                reviewers.length > 0 && <ReadOnlyMultiSelectValues values={reviewerDetails} />
              }
            </>
          }

          <div>
            <label>{I18n.t("documents")}</label>
          </div>
          {editMode && <p className="description">{I18n.t("docusign_documents_description")}</p>}
          {editMode ?
            <>
              <Select
                options={(availableDocs || []).map((r) => ({
                  value: r.id,
                  label: r.name,
                }))}
                value={docs.map((r) => parseInt(r.id))}
                onChange={handleDocsSelect}
                isMulti
              />
              {docs.map((r) => (
                <div key={r.id} className="d-none">
                  <input type="hidden" name="monitoring_report[sign_documents][][id]" value={r.id} />
                </div>
              ))}
            </>
             : 
            <>
              {
                availableDocs.length > 0 && <ReadOnlyMultiSelectValues values={docs} />
              }
            </>
          }
        </Col>

        {editMode && (
          <ActionButtons
            onSave={onSave}
            onCancel={(e) => {
              e.preventDefault();
              setEditMode(!editMode);
            }}
          />
        )}
      </Row>
    </form>
  );
};

const DocusignPhaseEdit = (props) => {
    return (
      <>
        <GeneralDetails {...props} />
      </>
    );
  };
  
  export default DocusignPhaseEdit;